<template>
  <v-dialog
    :value="getModal.toggle"
    persistent
    max-width="600px"
    transition="dialog-transition"
  >
    <v-card class="pa-8 tw-text-center">
      <div class="tw-text-3xl tw-font-semibold tw-text-gray-800 tw-mb-8">
        {{ getModal.mensagem }}
      </div>
      <button class="modal-ok-btn" @click="close">OK</button>
    </v-card>
  </v-dialog>
</template>

<script>
// Modal global de aviso. Substitui o `alert()` nativo, que travava a thread do
// navegador: enquanto um alert está aberto, nenhum timer roda — nem o vTimeout
// que devolve o totem para a Home. Um aviso que ninguém fecha virava um totem
// congelado. Aqui o aviso é não-bloqueante e o totem continua se recuperando
// sozinho.
export default {
  computed: {
    getModal() {
      return this.$store.getters["getModal"];
    },
  },
  methods: {
    close() {
      this.$store.commit("closeModal");
    },
  },
};
</script>

<style scoped>
.modal-ok-btn {
  background: linear-gradient(135deg, #8c2667, #651946);
  color: #ffffff;
  border: none;
  border-radius: 0.75rem;
  padding: 1rem 3rem;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
}
</style>
